import React, { memo, useState, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';

import {
  getLsiId,
  getCompanyName,
  getCompanyAddress,
  getProductName,
  getInstallationAddress,
  getOldLineItemDetail,
  numberWithCommas,
  getJourneyProductName
} from 'home/view/upgrade-order/utils';

const TitleComponent = memo(({ isExpanded = false, circuitId = '', productName = '', currentBw = '', arc = '' }) => {
  return isExpanded ? (
    <div className="upgrade-header-open">
      <div className="title pad-bottom-0">Existing Site Details</div>
      <label className="field_label">The following are the details for the existing site.</label>
    </div>
  ) : (
    <Fragment>
      <div className="upgrade-header-open">
        <div className="title pad-bottom-0">Existing Site Details</div>
        <label className="field_label">The following are the details for the existing site.</label>
      </div>
      <ul className="upgrade-header-closed">
        {circuitId ? <li key={circuitId}>{`Circuit ID: ${circuitId} (Active Network)`}</li> : null}
        {productName ? <li key={productName}>{`Product Name: ${productName}`}</li> : null}
        {currentBw ? <li key={currentBw}>{`Current Bandwidth: ${currentBw}`}</li> : null}
        {arc ? <li key={arc}>{`Annual Recurring Charge: ₹ ${arc}`}</li> : null}
      </ul>
    </Fragment>
  );
});

const ExistingDetailsAccordion = ({ leadData = {} }) => {
  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: false
  });

  const defaultExistingDetails = {
    circuitId: getLsiId(leadData) || '-',
    productName: getJourneyProductName(getProductName(leadData)),
    currentBw: (getOldLineItemDetail(leadData) && getOldLineItemDetail(leadData).bandwidth) || '-',
    companyName: (getCompanyName(leadData) && getCompanyName(leadData).toTitleCase()) || '-',
    companyAddress: (getCompanyAddress(leadData) && getCompanyAddress(leadData).toTitleCase()) || '-',
    mediaType: (getOldLineItemDetail(leadData) && getOldLineItemDetail(leadData).media) || '-',
    installationAddress: (getInstallationAddress(leadData) && getInstallationAddress(leadData).toTitleCase()) || '-',
    serviceType:
      (getOldLineItemDetail(leadData) && getOldLineItemDetail(leadData).subProductName && `${getOldLineItemDetail(leadData).subProductName.toTitleCase()} Service`) || '-',
    annualRecurringCharge:
      getOldLineItemDetail(leadData) &&
      getOldLineItemDetail(leadData).price &&
      getOldLineItemDetail(leadData).price.rental &&
      numberWithCommas(getOldLineItemDetail(leadData).price.rental)
    // || "N/A"
  };

  return (
    <div className="existing-details upgrade-accordion">
      <Accordion
        autoScrollOnExpand
        title={
          <TitleComponent
            isExpanded={accordionMeta.isExpanded}
            circuitId={defaultExistingDetails.circuitId}
            productName={defaultExistingDetails.productName}
            currentBw={defaultExistingDetails.currentBw}
            arc={defaultExistingDetails.annualRecurringCharge}
          />
        }
        isExpanded={accordionMeta.isExpanded}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        <div className="upgrade-body">
          <div className="row">
            {defaultExistingDetails.circuitId ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Circuit ID</label>
                    <div className="value">{`${defaultExistingDetails.circuitId} (Active Network)`}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.productName ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Product Name</label>
                    <div className="value">{defaultExistingDetails.productName}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.currentBw ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Current Bandwidth</label>
                    <div className="value">{defaultExistingDetails.currentBw}</div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="row">
            {defaultExistingDetails.mediaType ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Media Type</label>
                    <div className="value">{defaultExistingDetails.mediaType}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.serviceType ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Service Type</label>
                    <div className="value">{defaultExistingDetails.serviceType}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.annualRecurringCharge ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Annual Recurring Charge</label>
                    <div className="value">&#8377; {defaultExistingDetails.annualRecurringCharge}</div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="row">
            {defaultExistingDetails.installationAddress ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Installation Address</label>
                    <div className="value">{defaultExistingDetails.installationAddress}</div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Accordion>
    </div>
  );
};

ExistingDetailsAccordion.propTypes = {
  leadData: PropTypes.object.isRequired
};

export default memo(ExistingDetailsAccordion);
